import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const HtmlDescription = ({
  content,
  size,
  className,
  color,
}: {
  content: string;
  className?: string;
  size: 'sm' | 'base';
  color: 'white' | 'foreground' | 'muted-foreground';
}) => {
  return (
    <HtmlRendererRaw
      className={cn(
        'ea-html-description',
        className,
        size === 'sm' && 'ea-html-description--sm',
        size === 'base' && 'ea-html-description--base',
        color === 'white' && 'text-white',
        color === 'foreground' && 'text-foreground',
        color === 'muted-foreground' && 'text-muted-foreground',
      )}
      html={content}
    />
  );
};
